import { EDIS_HISTORY_DATA, EDIS_HISTORY_ERROR, EDIS_HISTORY_HIDE_ERROR, EDIS_HISTORY_START_LOADER, EDIS_HISTORY_STOP_LOADER, } from "../interface/History";
const initialState = {
    data: [],
    historyLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const historyReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIS_HISTORY_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case EDIS_HISTORY_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EDIS_HISTORY_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case EDIS_HISTORY_START_LOADER:
            return Object.assign(Object.assign({}, state), { historyLoader: true });
        case EDIS_HISTORY_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { historyLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default historyReducer;
